import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { CheckCircle, Cancel } from '@mui/icons-material'
import { useMapContext } from '../../context/MapContext'
import { detectCityFromURL } from '../../utils/cityDetector'
import { buildCantonUrl } from '../../utils/cantonUrl'
import { useCities } from '../../context/CitiesContext'
import { setPopup, setAddMode, setTreeCoords } from '../../redux/slices/Map/map'
import * as RT from '../../config/routes'
import { Grid, Box } from '@mui/material'

import Botton from '.'
import _ from 'lodash'

const COLOR_POPUP = 'var(--color-green)'
const COLOR_PRIMARY = 'var(--color-primary)'
const COLOR_WHITE = 'var(--color-white)'
const COLOR_GREY = '#333333'

const gridStyle = {
  mt: 0,
  ml: 0,
  pr: 1,
  pb: 1,
  width: '100%',
  height: '50px',
  textAlignLast: 'right',
  justifyContent: 'space-evenly',
}

const styleDefaultButton = (bc, c, bcHover, cHover) => ({
  color: c,
  backgroundColor: bc,
  border: `1px solid ${c}`,
  width: '100%',
  fontSize: '12px',
  '&:hover': { backgroundColor: bcHover, color: cHover },
  '&:active': { boxShadow: 'none', opacity: 0.9 },
})

const BottonInside = ({ enableButton, hdleButtonCancel }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  let location = useLocation()
  const { getEnabledCantones } = useCities()
  const cantones = getEnabledCantones()

  const { map } = useMapContext()

  const { specieField, siteField, sectionField, pseudonymField, siteAcronym } =
    useSelector(state => state.treeFeatures.enableSaveButton)
  const errorFields = Boolean(
    specieField.error ||
      pseudonymField.error ||
      siteField.error ||
      siteAcronym.error ||
      sectionField.error
  )
  const emptyField = !Boolean(
    specieField?.selected &&
      pseudonymField?.selected?.length &&
      siteField?.selected &&
      siteAcronym?.selected &&
      sectionField?.selected
  )

  const disableButtonSave = _.isBoolean(enableButton)
    ? !enableButton
    : Boolean(errorFields || emptyField)

  const handleButtonCancel = () => {
    const currentCity = detectCityFromURL(location.pathname) || 'loja'
    const onResize = () => map.resize()

    // Resetear estados del mapa
    dispatch(setPopup({ open: false, code: null, id: null }))
    dispatch(setAddMode(false)) // Desactivar modo de captura de coordenadas
    dispatch(setTreeCoords({ lng: null, lat: null })) // Limpiar coordenadas temporales

    navigate(buildCantonUrl(currentCity, cantones, RT.MANAGEMENT), { replace: true })
    window.addEventListener('resize', onResize)
  }

  return (
    <Grid container spacing={1} sx={gridStyle}>
      <Grid item xs={6} sm={6}>
        <Box sx={{ width: '100%' }}>
          <Botton
            text="Cancelar"
            onClick={hdleButtonCancel ?? handleButtonCancel}
            variant="contained"
            startIcon={<Cancel />}
            styleButton={styleDefaultButton(
              COLOR_WHITE,
              COLOR_GREY,
              COLOR_WHITE,
              COLOR_GREY
            )}
          />
        </Box>
      </Grid>
      <Grid item xs={6} sm={6}>
        <Box sx={{ width: '100%' }}>
          <Botton
            disabled={disableButtonSave}
            text="Guardar"
            type="submit"
            variant="contained"
            startIcon={<CheckCircle />}
            styleButton={styleDefaultButton(
              COLOR_WHITE,
              COLOR_PRIMARY,
              COLOR_WHITE,
              COLOR_POPUP
            )}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default BottonInside
